export default __webpack_public_path__ + "static/farming-3-9e9742e0a3bd565714a50c7b77e02a28.png";